<script>
	import { fly } from "svelte/transition";
</script>

<div class="quikWikIconBox" in:fly={{ y: -20, duration: 1000 }}>
	<svg width="108" height="48" viewBox="0 0 108 48" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g filter="url(#filter0_d)">
			<rect
				x="3.8075"
				y="10.0031"
				width="57.4014"
				height="29"
				transform="rotate(-5.6975 3.8075 10.0031)"
				fill="#6C44A8"
			/>
		</g>
		<path
			d="M18.4448 13.5892C19.0972 13.5209 19.7232 13.5841 20.3227 13.7788C20.9205 13.9576 21.4488 14.2402 21.9075 14.6265C22.3821 15.0112 22.7695 15.4855 23.0698 16.0493C23.3844 16.5956 23.5758 17.1949 23.644 17.8474L24.3532 24.6264C24.3931 25.0083 24.3845 25.3872 24.3273 25.7632C24.2684 26.1233 24.1841 26.47 24.0741 26.8032L26.3991 29.1903L23.6063 29.4824L22.7954 28.6503C22.4434 28.9767 22.045 29.2436 21.6002 29.451C21.1553 29.6584 20.6704 29.7895 20.1452 29.8445L18.2595 30.0417C17.623 30.1083 17.0058 30.0522 16.4079 29.8735C15.8084 29.6788 15.2714 29.3891 14.7968 29.0044C14.3222 28.6197 13.9276 28.1542 13.6131 27.6079C13.3145 27.06 13.131 26.4599 13.0628 25.8074L12.3536 19.0284C12.2854 18.376 12.3406 17.7508 12.5194 17.153C12.7124 16.5376 13.0013 15.9926 13.386 15.518C13.7707 15.0434 14.237 14.6567 14.7849 14.3581C15.3312 14.0436 15.9225 13.853 16.5591 13.7864L18.4448 13.5892ZM21.3198 24.0026L20.723 18.2977C20.6931 18.0113 20.6258 17.7529 20.5213 17.5225C20.4151 17.2762 20.2724 17.0659 20.0933 16.8916C19.9142 16.7173 19.7083 16.594 19.4755 16.5219C19.2411 16.4338 18.9886 16.4039 18.7181 16.4322L16.8801 16.6244C16.3231 16.6827 15.8984 16.9282 15.6058 17.361C15.3292 17.7921 15.2208 18.2941 15.2807 18.867L15.9574 25.3357C16.0173 25.9086 16.2281 26.3852 16.5896 26.7657C16.9654 27.1286 17.4318 27.2809 17.9887 27.2226L19.8267 27.0303C20.1927 26.9921 20.5081 26.8545 20.7729 26.6177L17.1285 22.9208L19.9929 22.6211L21.3198 24.0026ZM33.0528 25.7433C33.4507 25.7017 33.7639 25.6207 33.9926 25.5002C34.2373 25.3781 34.4229 25.23 34.5494 25.0559C34.6919 24.8801 34.7833 24.6775 34.8237 24.448C34.864 24.2186 34.8709 23.9766 34.8442 23.722L34.0477 16.1075L36.8405 15.8154L38.1114 27.9651L35.3187 28.2572L35.2862 27.9469C35.0433 28.0849 34.7731 28.1936 34.4757 28.273C34.1943 28.3507 33.8865 28.407 33.5523 28.442L32.335 28.5693C31.6189 28.6442 30.9778 28.5906 30.4118 28.4085C29.8617 28.2248 29.3916 27.9603 29.0016 27.615C28.6099 27.2538 28.2927 26.8365 28.0502 26.3631C27.8219 25.8722 27.6811 25.3722 27.6278 24.863L26.7913 16.8666L29.5602 16.5769L30.3368 24.0004C30.3667 24.2869 30.4181 24.5469 30.4908 24.7806C30.5635 25.0143 30.6814 25.2192 30.8446 25.3952C31.0062 25.5552 31.22 25.6776 31.4863 25.7624C31.7509 25.8312 32.098 25.8432 32.5277 25.7982L33.0528 25.7433ZM43.3588 27.4162L40.5422 27.7108L39.2712 15.5611L42.0878 15.2664L43.3588 27.4162ZM41.9505 13.9536L39.1339 14.2483L38.8417 11.4555L41.6584 11.1608L41.9505 13.9536ZM55.9832 26.0955L52.8324 26.4251L48.2424 22.2239L48.7268 26.8546L45.9102 27.1493L44.2098 10.894L47.0264 10.5993L47.8579 18.5479L51.3228 14.3004L54.6407 13.9533L49.3794 20.1745L55.9832 26.0955Z"
			fill="white"
		/>
		<g filter="url(#filter1_d)">
			<rect
				x="56.2758"
				y="7.30576"
				width="48.7015"
				height="29"
				transform="rotate(8.91286 56.2758 7.30576)"
				fill="#A84480"
			/>
		</g>
		<path
			d="M73.113 30.7596L70.432 30.3504L69.2932 22.3833L65.8768 29.6551L63.2196 29.2495L61.4092 16.6156L64.0427 17.0176L65.198 25.0358L68.6217 17.7166L71.2789 18.1222L72.4178 26.0893L75.8579 18.8211L78.4914 19.2231L73.113 30.7596ZM81.2964 32.0088L78.4969 31.5815L80.3402 19.5053L83.1398 19.9327L81.2964 32.0088ZM83.339 18.6278L80.5394 18.2004L80.9631 15.4246L83.7627 15.8519L83.339 18.6278ZM93.8444 33.9242L90.7127 33.4461L87.3345 28.2205L86.6319 32.8232L83.8324 32.3959L86.2986 16.239L89.0982 16.6664L87.8922 24.5669L92.3188 21.3338L95.6166 21.8372L88.9528 26.5253L93.8444 33.9242Z"
			fill="white"
		/>
		<defs>
			<filter
				id="filter0_d"
				x="0.807495"
				y="4.30453"
				width="62.9969"
				height="38.5553"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
				<feOffset dx="-3" dy="4" />
				<feColorMatrix type="matrix" values="0 0 0 0 0.603 0 0 0 0 0.446667 0 0 0 0 0.8375 0 0 0 1 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
			</filter>
			<filter
				id="filter1_d"
				x="51.7827"
				y="7.30576"
				width="55.6065"
				height="40.1953"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
				<feOffset dx="3" dy="4" />
				<feColorMatrix type="matrix" values="0 0 0 0 0.975 0 0 0 0 0.50375 0 0 0 0 0.7865 0 0 0 1 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
			</filter>
		</defs>
	</svg>
</div>

<style>
	:global(html) {
		font-size: 20px;
	}
	@media screen and (max-width: 1000px) {
		:global(html) {
			font-size: 18px;
		}
	}
	@media screen and (max-width: 900px) {
		:global(html) {
			font-size: 16px;
		}
	}
</style>
